import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './Footer.css';

const Footer = () => {
  const [footer, setFooter] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await api.get('/footer');
        setFooter(response.data);
      } catch (error) {
        console.error('Failed to fetch footer:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFooter();
  }, []);

  if (loading) return null;

  // social_links is already an object from the API (no need to parse)
  const socialLinks = footer?.social_links || {};

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>{footer?.company_description || 'Your company description here'}</p>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            {footer?.address && <p>{footer.address}</p>}
            {footer?.phone && <p>Phone: {footer.phone}</p>}
            {footer?.email && <p>Email: {footer.email}</p>}
          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              {socialLinks.facebook && (
                <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                  Facebook
                </a>
              )}
              {socialLinks.twitter && (
                <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                  Twitter
                </a>
              )}
              {socialLinks.linkedin && (
                <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer">
                  LinkedIn
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{footer?.copyright_text || '© 2025 Your Company. All rights reserved.'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
